/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CableMarket {
    NationalCable = 'National Cable',
    LocalCableUpTo1MSubscribers = 'Local Cable (Up To 1M Subscribers)',
    LocalCable1MTo2MSubscribers = 'Local Cable (1M To 2M Subscribers)',
    LocalCable2MPlusSubscribers = 'Local Cable (2M Plus Subscribers)',
}
